// === HYDROGENIX CUSTOM JS ===

document.addEventListener('DOMContentLoaded', function () {

  // --- GALLERY ---
  const gallery = document.querySelector('.hx-hero__gallery');
  if (gallery) {
    const mainImg = gallery.querySelector('.hx-hero__main-img');
    const thumbs = gallery.querySelectorAll('.hx-hero__thumb');
    const images = Array.from(thumbs).map(t => t.dataset.full || t.src);
    let current = 0;

    function setActive(idx) {
      current = idx;
      if (mainImg) mainImg.src = images[idx];
      thumbs.forEach((t, i) => t.classList.toggle('active', i === idx));
    }

    thumbs.forEach((t, i) => t.addEventListener('click', () => setActive(i)));

    const prev = gallery.querySelector('.hx-gallery-prev');
    const next = gallery.querySelector('.hx-gallery-next');
    if (prev) prev.addEventListener('click', () => setActive((current - 1 + images.length) % images.length));
    if (next) next.addEventListener('click', () => setActive((current + 1) % images.length));

    if (thumbs.length) setActive(0);
  }

  // --- BUNDLE SELECTOR ---
  const bundleOpts = document.querySelectorAll('.hx-bundle-opt');
  const heroSentinel = document.querySelector('.hx-hero-atc-sentinel');
  const heroForm = heroSentinel ? heroSentinel.closest('form') : null;

  bundleOpts.forEach(opt => {
    opt.addEventListener('click', function () {
      bundleOpts.forEach(o => o.classList.remove('selected'));
      this.classList.add('selected');
      const variantId = this.dataset.variantId;
      const priceDisplay = document.querySelector('.hx-selected-price');
      if (variantId && heroForm) {
        const input = heroForm.querySelector('input[name="id"]');
        if (input) input.value = variantId;
      }
      const price = this.dataset.price;
      if (price && priceDisplay) priceDisplay.textContent = price + ' kr';
    });
  });
  // Select first bundle by default
  if (bundleOpts.length) bundleOpts[0].click();

  // --- ACCORDION ---
  document.querySelectorAll('.hx-accordion-trigger').forEach(trigger => {
    trigger.addEventListener('click', function () {
      const body = this.nextElementSibling;
      const isOpen = body.classList.contains('open');
      // Close all
      document.querySelectorAll('.hx-accordion-body').forEach(b => b.classList.remove('open'));
      document.querySelectorAll('.hx-accordion-trigger').forEach(t => t.classList.remove('open'));
      if (!isOpen) {
        body.classList.add('open');
        this.classList.add('open');
      }
    });
  });
  // Open first accordion
  const firstTrigger = document.querySelector('.hx-accordion-trigger');
  if (firstTrigger) firstTrigger.click();

  // --- STICKY ATC ---
  const heroAtcBtn = document.querySelector('.hx-hero-atc-sentinel');
  const stickyBar = document.querySelector('.hx-sticky-atc');
  if (heroAtcBtn && stickyBar) {
    const observer = new IntersectionObserver(([entry]) => {
      stickyBar.classList.toggle('visible', !entry.isIntersecting);
    }, { threshold: 0 });
    observer.observe(heroAtcBtn);
  }

  // --- STICKY ATC BUY ---
  const stickyBtn = document.querySelector('.hx-sticky-atc__btn');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () {
      const mainBtn = document.querySelector('.hx-atc-btn');
      if (mainBtn) mainBtn.click();
    });
  }

});
